import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { App, AppCategories, AppCategoryOption, Discipline } from '../../models';
import { SNACKBAR_CONSTANTS } from '../../shared/constants';
import { AppCategoriesDataService } from '../data-services';
import { AppCategoriesServiceModel } from './models';

@Injectable({
    providedIn: 'root'
})
export class AppCategoriesLogicService {

    model: AppCategoriesServiceModel = new AppCategoriesServiceModel();

    constructor(
        private _appCategoriesDataService: AppCategoriesDataService,
        private _snackBar: MatSnackBar
    ) { }

    getSubCategories(disciplineId: number | null): AppCategoryOption[] {
        return this.findDiscipline(disciplineId)?.subCategories ?? [];
    }

    loadAppCategories(): void {
        if (this.model.isLoaded || this.model.isLoading) {
            return;
        }

        this.model.isLoading = true;
        this._appCategoriesDataService.getAppCategories()
            .subscribe({
                next: (appCategories: AppCategories | null) => {
                    this.model.useCases = appCategories?.useCases ?? [];
                    this.model.disciplines = appCategories?.disciplines ?? [];
                    this.model.isLoaded = true;
                },
                error: () => {
                    this._snackBar.open(SNACKBAR_CONSTANTS.ITEM_ACTION_ERROR('app categories', 'loading'), SNACKBAR_CONSTANTS.CLOSE, { duration: 5000 });
                }
            })
            .add(() => {
                this.model.isLoading = false;
            });
    }

    setAppCategories(app: App, useCaseId: number | null, disciplineId: number | null, subCategoryId: number | null): void {
        if (!this.model.isLoaded) {
            return;
        }

        const discipline = this.findDiscipline(disciplineId);

        app.useCase = this.toOption(this.model.useCases.find((useCase: AppCategoryOption) => useCase.id === useCaseId));
        app.discipline = this.toOption(discipline);
        app.subCategory = this.toOption(discipline?.subCategories.find((subCategory: AppCategoryOption) => subCategory.id === subCategoryId));
    }

    private findDiscipline(disciplineId: number | null): Discipline | undefined {
        return this.model.disciplines.find((discipline: Discipline) => discipline.id === disciplineId);
    }

    private toOption(option: AppCategoryOption | Discipline | undefined): AppCategoryOption | undefined {
        return option ? { id: option.id, name: option.name } : undefined;
    }
}
